import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";


export interface AddressValidationRequest {

}

export interface AddressValidationResponse {

}

export interface GoogleAddressRequest {
    regionCode: string;                 // e.g. "US"
    locality: string;                   // e.g. "Mountain View"
    addressLines: string[];             // e.g. ["1600 Amphitheatre Pkwy"]

}

export interface GoogleAddressResponse {
    formattedAddress: string;           // e.g. "1600 Amphitheatre Parkway, Mountain View, CA 94043-1351, USA"
    postalAddress: PostalAddress;
}

export interface PostalAddress {
    regionCode: string;                 // e.g. "US"
    languageCode: string;               // e.g. "en"
    postalCode: string;                 // #####-####
    administrativeArea: string;         // state abbrev
    locality: string;                   // city
    addressLines: string[];             // array of address1, address2, etc.
}

@Injectable({
    providedIn: 'root'
})

export class GoogleService {
    constructor(private readonly http: HttpClient) { 
    }

    validateAddress(addressLines:string[],regionCode:string = "US"): Observable<any> {
        let requestBody = {
            "address": {
                regionCode: regionCode || "US",
                addressLines: addressLines
            },
            "enableUspsCass": true
        }
        return this.http.post<any>(environment.Google.googleAddressValidationUrl + environment.Google.googleAddressValidationKey, requestBody, { });
    }

}